import PublicLayout from "@/layouts/PublicLayout.vue";

import type { RouteRecordRaw } from "vue-router";

const publicRoutes: RouteRecordRaw[] = [
  {
    path: "/public/repair-file/prospect/:kind(picture|document)",
    name: "publicRepairFileProspectUpload",
    component: () => import("@/views/public/RepairFileProspectUploadView.vue"),
    meta: { layout: PublicLayout },
  },
  {
    path: "/public/pickup-request",
    name: "publicPickupRequest",
    component: () => import("@/views/public/PickupRequestView.vue"),
    meta: {
      layout: PublicLayout,
    },
  },
  {
    path: "/public/key-account-product/request-draft",
    name: "publicKeyAccountProductRequestDraft",
    component: () =>
      import("@/views/restricted/key-account-products/KeyAccountProductRequestDraftCreateView.vue"),
    meta: {
      layout: PublicLayout,
    },
  },
  {
    path: "/public/product-request/upload-nameplate",
    name: "publicProductRequestUploadNameplate",
    component: () =>
      import("@/views/public/ProductRequestUploadNameplateView.vue"),
    meta: {
      layout: PublicLayout,
    },
  },
  {
    path: "/public/repair-file/guarantee-proof",
    name: "publicRepairFileGuaranteeProofUpload",
    component: () =>
      import("@/views/public/RepairFileGuaranteeProofUploadView.vue"),
    meta: {
      layout: PublicLayout,
    },
  },
  {
    path: "/public/repair-file/upload-additional-attachment",
    name: "publicRepairFileAdditionalAttachmentUpload",
    component: () =>
      import("@/views/public/RepairFileAdditionalAttachmentUploadView.vue"),
    meta: {
      layout: PublicLayout,
    },
  },
];

export default publicRoutes;
